<div class="db-user-management">

  <div class="db-add-users-message" *ngIf="!workspaceClients.length">
    <div class="db-add-user-image-wrap">
      <img class="db-add-user-image" src="assets/images/user-management/add-user.svg" alt=""/>
    </div>
    <div class="db-add-user-title"><span>{{'text_client-management-tooltip-title' | dbText}}</span></div>
    <div class="db-add-user-desc">
      <span [innerHTML]="(!isCurrentWorkspaceInActive || currentSubscription?.subscriptionId === Config.defaultStarterPlanId ? 'text_userManagement__invite' : 'text_userManagement__upgrade') | dbText "></span>
    </div>
    <div>
      <a class="ds-btn-blue ds-btn-l" (click)="!isCurrentWorkspaceInActive && (!currentSubscription?.trialBoosterClient || currentSubscription?.subscriptionId === Config.defaultStarterPlanId) ? inviteUsers() : redirectToUpgrade()" [ngClass]="{'db-btn-green': isCurrentWorkspaceInActive && currentSubscription?.subscriptionId !== Config.defaultStarterPlanId}"><span [innerHTML]="(!isCurrentWorkspaceInActive || currentSubscription?.subscriptionId === Config.defaultStarterPlanId ? 'text_inviteUsers' : 'text_upgrade') | dbText | lowerCaseSpecificWords"></span></a> <!-- check with owner workspace id-->
    </div>
  </div>
  <div *ngIf="workspaceClients.length" class="db-user-management-content">
    <div class="db-user-management-header" >
      <div class="db-header">
        <div class="db-header-title"><span>{{'text_client-management-tooltip-title' | dbText}}</span></div>
        <div class="db-header-desc">
          <span [innerHTML]="'text_userManagement__add-user' | dbText"></span>
          <i class="db-icon db-icon-info-lined" [dsTooltip]="UMTooltipBody"  dsTooltipAlign="left"></i>
        </div>
      </div>
      <div class="db-invite-user">
        <a class="ds-btn-blue ds-btn-l" (click)="inviteUsers()"><span [innerHTML]="'text_inviteUsers' | dbText | lowerCaseSpecificWords"></span></a>
      </div>
    </div>
    <div class="db-search-wrap">
      <ds-search-input [width]="'260px'" [formControl]="searchTerm" [placeholder]="'text_searchEllipsis' | dbText"></ds-search-input>
    </div>
    <div *ngIf="!filteredWorkspaceClients.length" class="db-user-management__no-results">
      <h2 class="title" [innerHTML]="'text_emptySearchTitle' | dbText"></h2>
      <p class="text" [innerHTML]="'text_emptySearchDescription' | dbText"></p>
    </div>
    <div *ngIf="filteredWorkspaceClients.length" class="db-user-management__body">
      <div class="db-user-item" *ngFor="let client of filteredWorkspaceClients; let i = index">
        <div class="db-item-desc">
          <div class="db-user-img">
            <img dbGravatar [email]="client?.email" src="" size="100" alt=""/>
          </div>
          <div class="db-user-name">
            <div class="db-user-item-title" *ngIf="client?.name">Name</div>
            <div class="db-user-item-desc">
              <span class="db-name" *ngIf="client?.name">{{client?.name}}</span>
              <span class="db-user-status" *ngIf="!client?.status">Pending</span>
            </div>
          </div>
          <div class="db-user-email">
            <div class="db-user-item-title">Email</div>
            <div class="db-user-item-desc"> <span>{{client.email}}</span>  </div>
          </div>
          <div class="db-user-role">
            <div class="db-user-item-title">Role</div>
            <div class="db-user-item-desc"> <span>{{client?.role?.displayName}}</span>  </div>
          </div>
          <div class="db-user-sites">
          <div class="db-user-item-title">Sites</div>
          <div class="db-user-item-desc">
            <span *ngIf="client?.role?.roleId !== clientRoles.SITE_DEV
            || (client?.role?.roleId === clientRoles.SITE_DEV && !client?.status)">
              {{client?.role?.roleId !== clientRoles.SITE_DEV ? 'All Websites'
              : !client?.domains?.length ? 'Give access'
                : client?.domains?.length && client?.domains?.length > 1 ? client?.domains?.length + ' Websites' : '1 Website'}}
            </span>
            <a *ngIf="client?.role?.roleId === clientRoles.SITE_DEV && client?.status" (click)="updateUser(client)"
               class="db-link">
              {{ !client?.domains?.length ? 'Give access' :
              client?.domains?.length && client?.domains?.length > 1 ? client?.domains?.length + ' Websites' : '1 Website' }}
            </a>
          </div>
        </div>
        </div>
        <div class="db-buttons">
          <a *ngIf="!client?.status" (click)="resendInvitation(client.id)" class="db-resend-link">
            <span *ngIf="!resendLoading || clientId !== client.id">Resend</span>
            <db-loading-circular-spinner *ngIf="resendLoading && clientId === client.id"></db-loading-circular-spinner>
          </a>
          <span class="db-edit-btn"
                *ngIf="client?.status" (click)="updateUser(client)"><i class="db-icon db-icon-edit"></i></span>
          <div dbDropdownList [items]="removeItem"  [dbDropdownListPosition]="'dropdown'" [toggleOnHover]="false"
               class="db-remove-user__dropdown" [ngClass]="{'db-button_dropdown-disabled': loading}" [item]="{client: client, index: i}">
            <a  class="more-icon-wrap" >
              <i class="db-icon db-icon-more2"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<ng-template #UMTooltipBody>
  <p class="ds-tooltip-title">Admin</p>
  <p>Access to all workspace features & billing except user management.</p>
  <br>
  <p class="ds-tooltip-title">Contributor</p>
  <p>Access to adding, removing & managing all websites in the workspace.<br>
    No access to user management, white label & billing.<br>
    Perfect for lead developers & project managers.</p>
  <br>
  <p class="ds-tooltip-title">Member</p>
  <p>Access only to selected websites’ live or staging environments.<br>
    Perfect for clients, developers, designers or marketers.</p>
</ng-template>
